import Registration from './registration'
import Login from './login'
import Profile from './profile'
import CheckBalance from './check-balance'
import ClaimGiftCard from './claim-gift-card'
import GiftCard from './gift-card'
import Race from './race'
import Ninja from './ninja'
import Cart from './cart'
import PasswordReset from './password-reset'
import EmailVerify from './email-verify'
import BuyPlayCard from './buy-play-card'
import BuyPlayCardsWithUpgrades from './buy-play-cards-with-upgrades'
import ReloadPlayCard from './reload-play-card'

// @deprecated: Use PageBookCsEventReservation instead
import PageBookAxeThrowing from './axe-throwing'
import PageBookCsEventReservation from './cs-event-reservation'

import PageBookCsReservation from './cs-reservation'

import BookTicket from './book-ticket'
import Unsubscribe from './unsubscribe'

export default {
  Registration,
  Login,
  Profile,
  CheckBalance,
  ClaimGiftCard,
  GiftCard,
  Race,
  Ninja,
  Cart,
  PasswordReset,
  EmailVerify,
  BuyPlayCard,
  BuyPlayCardsWithUpgrades,
  ReloadPlayCard,
  PageBookAxeThrowing,
  PageBookCsEventReservation,
  PageBookCsReservation,
  ...BookTicket,
  Unsubscribe,
}
